import { Component } from 'vue-property-decorator';
import { mapState } from 'vuex';
import VueBase from '@/VueBase';
import helper, { _loadComponent } from '@/services/helper';
import Q from 'q';
import api from '@/services/api';
import loadImage from 'image-promise';
import { locales } from '@/i18n-setup';
import _ from 'lodash';
import printerApi from '@/services/printer';
import to from 'await-to-js';

const component = _loadComponent('StartRules/');
const StartRules = (resolve: any) => {
  resolve(component || {});
};

async function loadSubjectImages(subjects: SubjectModel[]) {
  if (subjects.length === 0) {
    return;
  }

  var first = subjects[0];
  let images = _.chain(first.Candidates)
    .map((x) => x.PictureURL)
    .filter((x) => (x ? true : false))
    .uniq()
    .value();

  console.info('LOAD_FIRST_START', images.length);
  console.time('LOAD_FIRST_ELAPSED');
  if (images.length) {
    var loadPromise = loadImage(images);
    var [error, res] = await to(loadPromise);
    if (error) console.log(error);
  }
  console.timeEnd('LOAD_FIRST_ELAPSED');

  if (subjects.length > 1) {
    let other = _.chain(subjects)
      .map((x) => x.Candidates)
      .flatten()
      .map((x) => x.PictureURL)
      .filter((x) => (x ? true : false))
      .uniq()
      .difference(images)
      .value();

    if (other.length) {
      console.info('LOAD_OTHER_START', other.length);
      console.time('LOAD_OTHER_ELAPSED');
      var loadPromise = loadImage(other);
      var [error, res] = await to(loadPromise);
      if (error) console.log(error);
      console.timeEnd('LOAD_OTHER_ELAPSED');
    }
  }
}

@Component({
  computed: {
    ...mapState({
      ShowLanguages: 'ShowLanguages',
      CommitteeEmail: 'CommitteeEmail',
      ShowVoterName: 'ShowVoterName',
      VoterName: 'FullName',
      ShowPrinter: 'ShowPrinter',
      ShowSelectSubject: 'ShowSelectSubject',
      StartInstructionHTML: 'StartInstructionHTML',
      CanCancelVote: 'CanCancelVote',
      AnonymousVoteEnabled: 'AnonymousVoteEnabled',
    }),
  },
  components: {
    StartRules,
    StartInstructions: (resolve) => _loadComponent('StartInstructions/', resolve),
  },
})
export default class StartMixins extends VueBase {
  public readonly ShowLanguages!: string;
  public readonly CommitteeEmail!: string;
  public readonly ShowVoterName!: string;
  public readonly VoterName!: string;
  public readonly ShowPrinter!: boolean;
  public readonly ShowSelectSubject!: boolean;
  public readonly CanCancelVote!: boolean;
  public readonly AnonymousVoteEnabled!: boolean;
  public readonly StartInstructionHTML!: string;
  public readonly HasStartRules: boolean = component ? true : false;

  public subjects: SelectOption[] = [];

  get showCancel() {
    if (process.env.VUE_APP_MODE === 'SA') {
      return !this.AnonymousVoteEnabled || this.CanCancelVote;
    }
    return false;
  }

  async mounted() {
    if (process.env.VUE_APP_MODE === 'WEB' || process.env.VUE_APP_MODE === 'SA') {
      if (this.ShowSelectSubject) {
        var resp = await (await api.GetVoteSubjects()).getData();
        if (!resp) return;

        this.subjects = resp.Subjects;
      }
    }
    helper.close();
  }

  async onCancelVoteClick() {
    var confirms = await helper.cancelVote();
    if (!confirms) return;

    if (process.env.VUE_APP_MODE === 'SA') {
      this.$router.push({ name: 'VoterAssign' });
    }
    if (process.env.VUE_APP_MODE === 'WEB') {
      await api.Logout();
      this.$router.push({ name: 'Login' });
    }
    if (process.env.VUE_APP_MODE === 'CS') {
      this.$router.push({ name: 'Start' });
    }
  }

  async onStartClick(subjectId?: string) {
    if (this.ShowPrinter) {
      if (!printerApi.isBluetoothPrinterConnected()) {
        helper.swalWarning(this.$t('vs.printer.error.noconnection') as string);
        return;
      }
      if (printerApi.isLowOnPaperOrNoConnection()) {
        helper.swalWarning(this.$t('vs.printer.error.lowpaper') as string);
        return;
      }
    }

    var acceptResult = await this.acceptRules();
    if (!acceptResult) {
      return;
    }
    await Q.delay(150);
    helper.swalShowLoading();
    let apiResult = await (await api.GetVoteData(subjectId)).getData(true);
    if (!apiResult) {
      if (process.env.VUE_APP_MODE === 'SA') {
        this.$router.push({ name: 'VoterAssign' });
      }
      if (process.env.VUE_APP_MODE === 'WEB') {
        this.$router.push({ name: 'Login' });
      }
      return false;
    }
    // Dont nned it. We get the name from api.Config
    /*
    this.$store.commit('UpdateName', {
      DisplayName: apiResult.Data.DisplayName,
      ProfileName: apiResult.Data.ProfileName,
    });
    */
    this.$store.commit('SetVotingInfo', apiResult.Data.Subjects);

    await loadSubjectImages(apiResult.Data.Subjects);
    if (this.ShowPrinter) {
      printerApi.setDirection('LEFT');
      printerApi.printLine('Start OK');
    }

    this.$router.push({ name: 'Vote', params: { subjectIndex: '0' } });
  }

  async acceptRules() {
    if (!this.HasStartRules) {
      return true;
    }
    var rules = (this.$refs.StartRules as Vue)?.$el;
    if (!rules) {
      return true;
    }

    var result = await helper.swalConfirm({
      html: rules as any,
      confirmButtonText: this.$t('vs.start.popup.rules.btn.confirm') as string,
      cancelButtonText: this.$t('vs.start.popup.rules.btn.cancel') as string,
      icon: 'warning',
      customClass: {
        container: 'swal-lg',
      },
    });
    return result === true;
  }
}
